import { render } from "./EventPlayerStatus.vue?vue&type=template&id=312d4c24&scoped=true"
import script from "./EventPlayerStatus.vue?vue&type=script&lang=js"
export * from "./EventPlayerStatus.vue?vue&type=script&lang=js"

import "./EventPlayerStatus.vue?vue&type=style&index=0&id=312d4c24&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312d4c24"]])

export default __exports__